
import { defineComponent, onBeforeMount, reactive, watch, PropType } from 'vue'

// @components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

// @types
import { Prediction } from '@/new-services/types/prediction'

// @services
import predictionAPI from '@/new-services/prediction.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        TheButton,
        Loader,
    },
    props: {
        dispatcherSectorIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            prediction: null as Prediction | null,
        })

        const loadPrediction = async () => {
            if (!props.dispatcherSectorIds) {
                state.prediction = null
                return
            }

            try {
                state.is_loading = true

                const response = await predictionAPI.getPrediction({
                    dispatcherSectorIds: props.dispatcherSectorIds,
                })
                state.prediction = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении данных для прогнозирования произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadPrediction)

        watch(
            () => props.dispatcherSectorIds,
            () => {
                loadPrediction()
            }
        )

        return {
            state,
            loadPrediction,
        }
    },
})
